const TRANS_SS_MODES = {
    boost: 'Boost',
    comfort: 'Confort',
    eco: 'Eco',
    frostprotection: 'Arrêt/Antigel',
};

const TRANS_SS_MODES_SAUTER = {
    comfort: 'Confort',
    eco: 'Eco',
    frostprotection: 'Antigel',
    off: 'Arrêt',
};

const TRANS_SS_MODES_SHOGUN = {
    heating: 'Chauffage',
    cooling: 'Climatisation',
    stop: 'Arrêt',
};

const TRANS_SPA_MODES = {
    filter_3h: 'Filtration 3h',
};

export {
    TRANS_SS_MODES,
    TRANS_SS_MODES_SAUTER,
    TRANS_SS_MODES_SHOGUN,
    TRANS_SPA_MODES,
};
